<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-29 10:41:41
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-27 18:05:28
 * @Description: file content
 query参数
 regtype sale销售 agent中介
 -->
<template>
  <div class="t9_my">
    <MineHf v-if="isHuafa"></MineHf>
    <Mine v-else></Mine>
    <Tabbar7></Tabbar7>
  </div>
</template>

<script>
import util from "@/utils/utils";

const Tabbar7 = () => import("@/components/tabbar7");
const Mine = () => import("@/components/mine");
const MineHf = () => import("@/components/mine_hf");

export default {
  components: {
    Mine,
    MineHf,
    Tabbar7
  },
  props: {},
  data() {
    return {
      isHuafa: util.checkIsHuafa() //是否华发
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
.t9_my {
}
</style>